import React from 'react';
import cbmsTitleImage from "../../assets/images/home/carousel-slider/cbms-title-for-slider.png";
import CarouselCaption from "./carouselCaption";
import {NavLink} from "react-router-dom";

const CarouselItem = ({item, count}) => {
    const handleCreateNewAccount = () => {
        window.location.href = 'https://cusbond.gov.bd/signup';
    }
    return (
        <div className={`carousel-item ${count === 0 && ' active'}`}>
            <img
                className="d-block w-100 slider-image"
                src={`data:image/jpg;base64,${item.sliderBase64}`}
                alt={item.sliderTag}
            />
            <div className="carousel__overlay"></div>
            <CarouselCaption>
                <img
                    className="cbms-title-for-slider"
                    src={cbmsTitleImage}
                    alt=""
                />
                <div className="d-flex flex-column flex-xl-row justify-content-center my-1 my-sm-3 mb-xl-5">
                    <div className="d-flex justify-content-center">
                        <div className="dropup">
                            <button className="cbms-btn login-btn" data-toggle="dropdown" aria-haspopup="true"
                               aria-expanded="false">
                                Login
                            </button>
                            <div className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                                <a className="dropdown-item" href="https://cusbond.gov.bd/login">Bonder</a>
                                <a className="dropdown-item" href="https://cusbond.gov.bd/lien-bank/login">Lien Bank</a>
                                <NavLink className="dropdown-item" to="/admin/login">Admin</NavLink>
                            </div>
                        </div>
                        <button onClick={handleCreateNewAccount} className="cbms-btn signout-btn mx-2">
                            Create New Account
                        </button>
                    </div>
                    {/*<div className="mt-2 mt-md-4 mt-xl-0">*/}
                    {/*    <div className="custom-input-group">*/}
                    {/*        <img*/}
                    {/*            className="search-icon"*/}
                    {/*            src={searchIcon}*/}
                    {/*            alt=""*/}
                    {/*        />*/}

                    {/*        <input*/}
                    {/*            className="search-input"*/}
                    {/*            type="text"*/}
                    {/*            placeholder="Search"*/}
                    {/*        />*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                </div>
            </CarouselCaption>
        </div>
    );
};

export default CarouselItem;
